// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// Material UI
import {
  Box,
  Typography,
} from "@mui/material";

// Icons
import CircleIcon from '@mui/icons-material/Circle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';


// ----------------------------------------------------------------------------
//   Helper Component: "REC" Icon
// ----------------------------------------------------------------------------

function RecordingIndicator({ active = false, showBg = true }) {

  // Set the icon color
  const color = active ? 'rgba(255, 0, 0)' : 'rgba(223, 223, 223)';

  return (
    <Box
      display="flex" alignItems="center" justifyContent="center" gap="4px"
      backgroundColor={ showBg ? "rgba(0, 0, 0, 0.5)" : "" }
      padding={1} borderRadius={2}
      className="noselect"
    >
      {
        active
          ? <RadioButtonCheckedIcon sx={{ color }} fontSize="" />
          : <CircleIcon             sx={{ color }} fontSize="" />
      }
      <Typography color={ color } sx={{ pointerEvents: 'none' }} fontFamily="monospace">
        REC
      </Typography>
    </Box>
  )
}


// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default RecordingIndicator;
